import { render, staticRenderFns } from "./nbn-check-list-details-fttc.vue?vue&type=template&id=107af56a&scoped=true"
import script from "./nbn-check-list-details-fttc.vue?vue&type=script&lang=js"
export * from "./nbn-check-list-details-fttc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107af56a",
  null
  
)

export default component.exports